import { useEffect } from 'react';

import { FabricObjectWithSrc, extractFabricObjectMovementProperties, scaleBackImages } from '../../../../shared/Helpers';

function useScaleBackImages(
  centringLeftScale: number,
  leftScale: number,
  topScale: number,
  onImageChange: (scaledImages: ReturnType<typeof scaleBackImages>) => void,
  presentFabricImages: FabricObjectWithSrc[],
  subsampleFactor: number
) {
  useEffect(() => {
    if (presentFabricImages) {
      const scaledImages = scaleBackImages(
        presentFabricImages.map(extractFabricObjectMovementProperties as any),
        leftScale,
        centringLeftScale,
        topScale,
        subsampleFactor
      );

      onImageChange(scaledImages);
    }
  }, [centringLeftScale, leftScale, onImageChange, presentFabricImages, topScale]);
}

export default useScaleBackImages;
